import {CLStore} from 'common/src/redux/store';
import {ZodTypeAny} from 'zod';
import {ToolName} from '../copilot.enums';
import {Tool} from '../copilot.types';
import generalNavigationTool from './generalNavigationTool/generalNavigationTool';
import getFilesTool from './getFilesTool';

const UNIVERSAL_TOOL_NAMES: string[] = [ToolName.GetFiles, ToolName.GeneralNavigation];

const toolMap = new Map<string, Tool<ZodTypeAny>>();

function registerUniversalTools(store: CLStore): void {
  registerTool(getFilesTool());
  registerTool(generalNavigationTool(store.getState));
}

function registerTool(tool: Tool<ZodTypeAny>): void {
  toolMap.set(tool.name, tool);
}

function getToolByName(name: string): Tool<ZodTypeAny> | undefined {
  return toolMap.get(name);
}

function getToolsByNames(names: string[]): Tool<ZodTypeAny>[] {
  return names.reduce<Tool<ZodTypeAny>[]>((tools, name) => {
    const tool = toolMap.get(name);

    if (tool) {
      tools.push(tool);
    }

    return tools;
  }, []);
}

function getUniversalTools(): Tool<ZodTypeAny>[] {
  return getToolsByNames(UNIVERSAL_TOOL_NAMES);
}

function getAllRegisteredTools(): Tool<ZodTypeAny>[] {
  return Array.from(toolMap.values());
}

function resetToolRegistry(): void {
  toolMap.clear();
}

export {
  registerTool,
  registerUniversalTools,
  getToolByName,
  getToolsByNames,
  getUniversalTools,
  getAllRegisteredTools,
  resetToolRegistry,
};
